import { ITelemetryItem } from '@microsoft/applicationinsights-web';

import { ERROR_ORIGIN_DIMENSION } from '../constants/error-origin.constants';

interface ExceptionStackFrame {
  fileName?: string;
  assembly?: string;
}

interface ExceptionDetails {
  parsedStack?: ExceptionStackFrame[];
  stack?: string;
}

export function findOriginFrame(stack: string): string {
  return stack.split('\n').find((line) => line.includes('://')) ?? '';
}

export function tagExceptionOrigin(
  item: ITelemetryItem,
  originValue: string,
  matchesOriginFrame: (frame: string) => boolean,
  matchesStack: (stack: string | null | undefined) => boolean
): void {
  try {
    if (item?.baseType !== 'ExceptionData' || hasHandler(item)) {
      return;
    }

    const exceptionDetails = (item.baseData?.['exceptions'] as ExceptionDetails[] | undefined)?.[0];
    const originFrame = exceptionDetails?.parsedStack?.[0];
    const origin = originFrame?.fileName ?? originFrame?.assembly ?? '';
    const isMatchingOrigin = origin ? matchesOriginFrame(origin) : matchesStack(exceptionDetails?.stack);

    if (isMatchingOrigin) {
      item.data = item.data ?? {};
      item.data[ERROR_ORIGIN_DIMENSION] = originValue;
    }
  } catch {
    return;
  }
}

function hasHandler(item: ITelemetryItem): boolean {
  return !!(item.baseData?.['properties']?.['handler'] ?? item.data?.['handler']);
}
